import { create } from 'zustand';
import { AuthSlice, createAuthSlice } from './authSlice';
import { createLocaleSlice, LocaleSlice } from './localeSlice';
import { CreateSelectedPlotSlice, SelectedPlotSlice } from './plotSlice';
import { FarmProfileSlice, createFarmProfileSlice } from './farmProfileSlice';
import { NewChatSlice, createNewChatSlice } from './newChatSlice';

export type StoreState = AuthSlice &
  LocaleSlice &
  SelectedPlotSlice &
  FarmProfileSlice &
  NewChatSlice;
/**
 * IMPORTANT: use global stores like this one ONLY client-side.
 * https://github.com/pmndrs/zustand/discussions/2326#discussioncomment-10102892
 * When store state isn't needed outside of components, it's better to use Zustand along with the Context API
 * ref: https://zustand.docs.pmnd.rs/guides/nextjs
 * guide: https://tkdodo.eu/blog/zustand-and-react-context
 */
export const useBoundStore = create<StoreState>((...a) => ({
  ...createAuthSlice(...a),
  ...createLocaleSlice(...a),
  ...CreateSelectedPlotSlice(...a),
  ...createFarmProfileSlice(...a),
  ...createNewChatSlice(...a),
}));
